export default "__VITE_ASSET__zu0HOiKr__"